/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";

const ClosedSessionPopup = ({ show }) => {
  useEffect(() => {
    document.title = "App moved to new tab";
    // replaceFavicon("/assets/images/error-favicon.png");
  }, []);

  // function replaceFavicon(href) {
  //   let link = document.querySelector("link[rel='icon']");
  //   if (!link) {
  //     link = document.createElement("link");
  //     link.rel = "icon";
  //     document.head.appendChild(link);
  //   }

  //   link.type = "image/png";
  //   link.href = href + "?v=" + Date.now();
  // }

  return (
    <div className="bg--dark border-radius h-100">
      <Modal show={show} backdrop="static" size="xs">
        <Modal.Body className="">
          <div className="align-items-center justify-content-center ">
            You opened this app in a new tab, so this one has been deactivated.
            Please continue in your newest tab. Thanks.
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ClosedSessionPopup;
